// Shared by the Ocean Guide screen and the daily social post generator.
export const getJapaneseMeteorShowerCopy = (name, distance, { weatherCaution = true } = {}) => ({
  title: distance === 0 ? `今夜は${name}の見頃です` : `${name}は明日ごろが見頃です`,
  detail: weatherCaution ? "天気に注意しながら、夜空を見上げてみてください。" : "",
});
